import { trackLaunchAppAction, trackEvent } from '../utils';
import { utils } from '../../utils';
const { copy } = utils;
export default function showPassphraseView(link, showCopyView = false) {
    const rootView = document.createElement('div');
    const containerView = document.createElement('div');
    const titleText = document.createElement('div');
    const contentText = document.createElement('div');
    const btnImg = document.createElement('img');
    const closeBtnImg = document.createElement('img');
    rootView.className = 'launch-app-passphrase-view';
    rootView.style.position = 'fixed';
    rootView.style.top = '0';
    rootView.style.left = '0';
    rootView.style.zIndex = '9999';
    rootView.style.width = '100vw';
    rootView.style.height = '100vh';
    rootView.style.textAlign = 'center';
    rootView.style.display = 'flex';
    rootView.style.flexDirection = 'column';
    rootView.style.justifyContent = 'center';
    rootView.style.alignItems = 'center';
    rootView.style.backgroundColor = 'rgba(0, 0, 0, .6)';
    containerView.style.backgroundColor = '#FFFFFF';
    containerView.style.width = '92.27vw';
    containerView.style.borderRadius = '4.93vw';
    containerView.style.position = 'relative';
    // title
    titleText.style.color = '#535353';
    titleText.style.fontSize = '5.2vw';
    titleText.style.marginTop = '9.33vw';
    titleText.style.fontWeight = 'bold';
    titleText.innerText = '无法打开？';
    // 内容描述文字
    contentText.style.color = '#535353';
    contentText.style.fontSize = '4.8vw';
    contentText.style.lineHeight = '6.93vw';
    contentText.style.width = '83.2vw';
    contentText.style.margin = '10.27vw auto 8vw';
    contentText.style.boxSizing = 'content-box';
    contentText.style.textAlign = 'center';
    contentText.style.fontWeight = 'bold';
    contentText.innerText = '可能是当前应用不支持唤醒我们，试试 复制滴口令后打开【滴滴出行APP】查看吧～';
    // 复制滴口令按钮图片
    btnImg.style.width = '89.6vw';
    btnImg.style.height = '19.87vw';
    btnImg.style.marginBottom = '3.2vw';
    btnImg.src = 'https://ut-static.udache.com/webx/ut/lC_ooriBNd-_0sJu6lFWo.png';
    btnImg.className = 'copy-passphrase-btn';
    // 关闭按钮图片
    closeBtnImg.style.width = '26vw';
    closeBtnImg.style.height = '14.13vw';
    closeBtnImg.style.position = 'absolute';
    closeBtnImg.style.right = '3.73vw';
    closeBtnImg.style.bottom = '3.2vw';
    closeBtnImg.src = 'https://ut-static.udache.com/webx/ut/YlJIrHx85yY5zwyBRlDQs.png';
    closeBtnImg.className = 'close-popup-btn';
    containerView.appendChild(titleText);
    containerView.appendChild(contentText);
    containerView.appendChild(btnImg);
    rootView.appendChild(containerView);
    // 直接展示复制成功后的弹窗
    if (showCopyView) {
        updateView();
        copy(link);
    }
    else {
        // 埋点：口令弹窗展现曝光
        trackEvent('launch_app_passphrase_popup_expose');
    }
    document.body.appendChild(rootView);
    rootView.onclick = function () {
        closePopup();
    };
    containerView.onclick = function (e) {
        stopBubble(e);
    };
    btnImg.onclick = function (e) {
        stopBubble(e);
        copy(link);
        updateView();
        trackLaunchAppAction(link);
        // 埋点：复制滴口令按钮点击
        trackEvent('launch_app_passphrase_copy_btn_click');
    };
    closeBtnImg.onclick = function () {
        closePopup();
        // 埋点：关闭按钮点击
        trackEvent('launch_app_passphrase_close_popup_btn_click');
    };
    function closePopup() {
        rootView.remove();
    }
    function updateView() {
        titleText.innerText = '复制成功';
        titleText.style.marginTop = '7.07vw';
        contentText.innerText = '打开【滴滴出行APP】去试试吧～';
        contentText.style.margin = '4.67vw auto 20vw';
        containerView.removeChild(btnImg);
        containerView.appendChild(closeBtnImg);
        // 埋点：复制成功弹窗曝光
        trackEvent('launch_app_passphrase_copy_success_popup_expose');
    }
}
function stopBubble(e) {
    //如果提供了事件对象，则这是一个非IE浏览器 
    if (e && e.stopPropagation) {
        e.stopPropagation();
    }
    else {
        window.event.cancelBubble = true;
    }
}
